var map = {
	"./Router": 30412,
	"./Router.d": 18412,
	"./Router.d.ts": 18412,
	"./Router.js": 30412,
	"./Router.js.map": 65960,
	"./Router5": 61996,
	"./Router5.d": 14308,
	"./Router5.d.ts": 14308,
	"./Router5.js": 61996,
	"./Router5.js.map": 24900,
	"./Router6": 94132,
	"./Router6.d": 34668,
	"./Router6.d.ts": 34668,
	"./Router6.js": 94132,
	"./Router6.js.map": 84672
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 65248;